var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("Sorry, The Site Cannot Be Reached!")]),_c('bull-loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }